import * as React from "react";
const SvgFiRrGrinHearts = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-grin-hearts_svg__a)">
      <path
        fill="#062147"
        d="M12 0A12.013 12.013 0 0 0 0 12c.6 15.9 23.4 15.893 24 0A12.013 12.013 0 0 0 12 0m0 22A10.01 10.01 0 0 1 2 12c.5-13.248 19.5-13.244 20 0a10.01 10.01 0 0 1-10 10m5.842-6.458A6.83 6.83 0 0 1 12 19a6.84 6.84 0 0 1-5.848-3.458A1 1 0 0 1 7.2 14.024c1.538.58 3.158.909 4.8.976a15.4 15.4 0 0 0 4.792-.976 1 1 0 0 1 1.05 1.518M19 8.65c0 1.3-1.692 2.818-2.535 3.494a.74.74 0 0 1-.93 0c-5.7-4.279.059-7.109.465-3.494a1.5 1.5 0 1 1 3 0m-14 0a1.5 1.5 0 0 1 3 0c.41-3.617 6.167-.78.465 3.494a.74.74 0 0 1-.93 0C6.692 11.468 5 9.948 5 8.65"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-grin-hearts_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGrinHearts;
